@if (!inDropdown) {
	<app-single-select-dropdown
		[opties]="viewOptions"
		[selectedOptie]="getViewOption(view())"
		(onOptieClicked)="setView($event)"
		placeholder="Kies..."
	></app-single-select-dropdown>
}
@switch (view()) {
	@case (DateRangeView.MAAND) {
		@if (inDropdown) {
			<app-single-select-list
				[opties]="monthOptions()"
				[selectedOptie]="getMonthOption(range())"
				(onOptieClicked)="range.set($event)"
			></app-single-select-list>
		} @else {
			<app-single-select-dropdown
				[opties]="monthOptions()"
				[selectedOptie]="getMonthOption(range())"
				(onOptieClicked)="range.set($event)"
				placeholder="Kies..."
			></app-single-select-dropdown>
		}
	}
	@case (DateRangeView.AFGELOPEN) {
		@if (inDropdown) {
			<app-single-select-list
				[opties]="relativeDateOptions"
				[selectedOptie]="getRelativeDateOption(relative())"
				(onOptieClicked)="setRelative($event)"
			></app-single-select-list>
		} @else {
			<app-single-select-dropdown
				[opties]="relativeDateOptions"
				[selectedOptie]="getRelativeDateOption(relative())"
				(onOptieClicked)="setRelative($event)"
			></app-single-select-dropdown>
			<div class="selected-range">{{ prettyFormat(range()) }}</div>
		}
	}
	@case (DateRangeView.ONBEKEND) {
		<div class="onbekend">
			Pas dit filter aan via de Filters knop
		</div>
	}
	@default {
		@if (view()) {
			<app-date-picker-dropdown
				[inDropdown]="inDropdown"
				[view]="view()"
				[(range)]="range"
				[aantalSchooljaren]="aantalSchooljaren()"
				[eindSchooljaar]="eindSchooljaar()"
			></app-date-picker-dropdown>
			@if (!inDropdown && view() === DateRangeView.WEEK) {
				<!-- Toon de week nog een keer als datumrange (ipv weeknummer) -->
				<div class="selected-range">{{ prettyFormat(range()) }}</div>
			}
		}
	}
}
